const state = {
  mapbox_access_token: 'pk.eyJ1IjoiaXNha29yYWxsIiwiYSI6ImNtMXlwbW9kYjAwbmQybHFzZzR2Nm12d3AifQ.-9OyfZ60o5DAtR-KTCJH0A',
};

const mutations = {};

const actions = {};

const getters = {
  mapbox_access_token() {
    return state.mapbox_access_token;
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
